import { render, staticRenderFns } from "./CliBillingDetail.vue?vue&type=template&id=bdfab21c&scoped=true&"
import script from "./CliBillingDetail.vue?vue&type=script&lang=js&"
export * from "./CliBillingDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdfab21c",
  null
  
)

export default component.exports